'use strict';

var _ = require('lodash');
var CalendarFactory = function CalendarFactory(constants, momentService, configurationService, featureToggleService) {
  /**
   * Creates new seasonality calendar object
   * @param calendar
   * @param calendarMode either 'Demand' or 'Show-Up'
   * @constructor
   */

  function Calendar(calendar, calendarMode) {
    function getCalendarMetric(metric, metricList) {
      var metricLabel = _.isString(metric) ? metric : metric && metric.label;
      return metric ? _.find(metricList, {
        label: metricLabel
      }) : metricList[0];
    }
    var hep = configurationService.getHepMap();
    var constantsPrefix = calendarMode === 'Show-Up' ? 'SHOW_UP_' : '';
    var metrics = constants[constantsPrefix + 'METRICS'];
    var levels = constants[constantsPrefix + 'LEVELS'];
    if (featureToggleService.isDisabled('SPOS')) {
      levels = _.reject(levels, function (level) {
        return _.includes(level, 'POS');
      });
    }
    calendar = calendar || {};

    /**
     * An array of markets associated with this calendar
     * @type {Array.string}
     */
    this.markets = calendar.markets || [];
    this.selectedMarkets = calendar.selectedMarkets || [];
    this.domainName = calendar.domainName || (calendarMode === 'Demand' ? 'UntruncatedMarketDemand' : 'LegShowUpMetrics');
    this.name = calendar.name || '';
    this.metrics = metrics;
    this.metric = getCalendarMetric(calendar.metric, metrics);
    this.levels = levels;
    this.level = calendar.level || levels[0];
    /**
     * Date range start MomentFactory
     * @type {MomentFactory}
     */
    this.dateRangeFrom = calendar.dateRangeFrom || momentService.systemNow(momentService.FIELD.SEASONALITY_DATE_RANGE).subtract(52, 'weeks');

    /**
     * Date range end MomentFactory
     * @type {MomentFactory}
     */
    this.dateRangeTo = calendar.dateRangeTo || momentService.systemNow(momentService.FIELD.SEASONALITY_DATE_RANGE).subtract(1, 'days');
    this.minNumberOfSeasons = calendar.minNumberOfSeasons || {
      id: hep.SEASONALITY_MIN_OPTIMAL_SEASON
    };
    this.maxNumberOfSeasons = calendar.maxNumberOfSeasons || {
      id: hep.SEASONALITY_MAX_OPTIMAL_SEASON
    };
    this.outlierTolerance = calendar.outlierTolerance || parseFloat(hep.SEASONALITY_OUTLIER_TOLERANCE);
    this.minDevBetweenSeasons = calendar.minDevBetweenSeasons || parseFloat(hep.SEASONALITY_OPTIMAL_SEASON_CUTOFF_CV);
    this.minOutlierRange = constants.MIN_OUTLIER_RANGE;
    this.maxOutlierRange = constants.MAX_OUTLIER_RANGE;
    this.smoothingNumberOfWeeks = calendar.smoothingNumberOfWeeks || {
      id: parseInt(hep.SEASONALITY_SMOOTHING_NUMBER_OF_WEEKS)
    };
    /**
     * A list of DOW Groups.
     * @type {Array.DowGroup}
     */
    this.dowGroups = calendar.dowGroups || []; // typeof DowGroupFactory
    this.customDow = calendar.customDow || false;

    /**
     * A list of Events.
     * @type {Array.Event}
     */
    this.events = calendar.events || []; // typeof EventFactory
  }
  return Calendar;
};
CalendarFactory.$inject = ['SeasonalityConstants', 'MomentService', 'ConfigurationService', 'FeatureToggleService'];
module.exports = CalendarFactory;